import React from 'react';
import { MediaLabsIcon } from '@/components/MediaLabsLogo';
import { SafeImage } from '@/components/SafeImage';

/**
 * Circular author avatar.
 * - If the profile has an `avatar` image URL, it is shown.
 * - Otherwise the branded MediaLabs mark is rendered inside a clean white chip
 *   (premium + honest for a team byline; avoids stock faces and gradients on a
 *   sub-100px element per the design guidelines).
 */
const DIMS = { xs: 'w-6 h-6', sm: 'w-8 h-8', md: 'w-11 h-11', lg: 'w-14 h-14' };
const ICON = { xs: 12, sm: 15, md: 20, lg: 26 };

export const AuthorAvatar = ({ author, size = 'md', className = '' }) => {
  const box = `${DIMS[size] || DIMS.md} rounded-full shrink-0 overflow-hidden ${className}`;

  if (author?.avatar) {
    return (
      <div className={`${box} bg-secondary`} data-testid="author-avatar">
        <SafeImage
          src={author.avatar}
          alt={author.name || 'Author'}
          className="w-full h-full object-cover"
        />
      </div>
    );
  }

  return (
    <div
      className={`${box} bg-white border border-[color:var(--hairline)] shadow-[var(--shadow-soft)] flex items-center justify-center`}
      aria-label={author?.name || 'MediaLabs'}
      data-testid="author-avatar"
    >
      <MediaLabsIcon size={ICON[size] || ICON.md} />
    </div>
  );
};
